import * as React from 'react'
import type { SVGProps } from 'react'
function SvgMsKlimadashboardIconsNaviInfoI(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="Ebene 1"
      fill="currentColor"
      id="MS_Klimadashboard_Icons_Navi_info_i_svg__Ebene_1"
      viewBox="0 0 24.08 24.08"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        className="MS_Klimadashboard_Icons_Navi_info_i_svg__cls-1"
        d="M12.04 0C5.39 0 0 5.39 0 12.04s5.39 12.04 12.04 12.04 12.04-5.39 12.04-12.04S18.69 0 12.04 0Zm0 22.07c-5.54 0-10.03-4.49-10.03-10.03S6.5 2.01 12.04 2.01c5.54 0 10.03 4.49 10.03 10.03 0 5.54-4.49 10.03-10.03 10.03Z"
      />
      <path
        className="MS_Klimadashboard_Icons_Navi_info_i_svg__cls-1"
        d="M12.24 4.9c-.7 0-1.28.55-1.28 1.21s.58 1.21 1.28 1.21 1.28-.54 1.28-1.21-.58-1.21-1.28-1.21ZM11.22 8.93h2.02v10.4h-2.02z"
      />
    </svg>
  )
}
export default SvgMsKlimadashboardIconsNaviInfoI
